import {createApi} from '@reduxjs/toolkit/query/react';
import {customBaseQueryWithCaptcha} from '~/common/rtk-query/queries';

export const api = createApi({
  reducerPath: 'cart',
  baseQuery: customBaseQueryWithCaptcha,
  tagTypes: ['Cart', 'Packages', 'Event'],
  endpoints: () => ({}),
});
